import React from 'react';

function Lock({ width }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width || '18'} viewBox="0 0 18 19" fill="none">
      <g clipPath="url(#clip0_4413:18679hh8)">
        <path
          d="M8.9998 0.267578C6.5185 0.267578 4.4998 2.28628 4.4998 4.76758V7.46758H3.5998C2.6071 7.46758 1.7998 8.27488 1.7998 9.26758V16.4676C1.7998 17.4603 2.6071 18.2676 3.5998 18.2676H14.3998C15.3925 18.2676 16.1998 17.4603 16.1998 16.4676V9.26758C16.1998 8.27488 15.3925 7.46758 14.3998 7.46758H13.4998V4.76758C13.4998 2.28628 11.4811 0.267578 8.9998 0.267578ZM14.3998 9.26758L14.4016 16.4676H3.5998V9.26758H14.3998ZM6.2998 7.46758V4.76758C6.2998 3.27898 7.5112 2.06758 8.9998 2.06758C10.4884 2.06758 11.6998 3.27898 11.6998 4.76758V7.46758H6.2998Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_4413:18679hh8">
          <rect width="18" height="18" fill="white" transform="translate(0 0.267578)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Lock;
